import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, utility } = useTheme();

  return {
    base: css`
      border: 0;
      padding: 0 0 16px 0;
      cursor: pointer;
      height: 100%;
      background-color: ${colors.white};
      font-family: 'FS DILLON';
      display: block;
      width: 100%;
      margin-bottom: 16px;
      border-bottom: 1px solid #ddd;

      &:hover {
        svg {
          transition: 0.4s ease-in;
          transform: translateX(50%);
        }
      }
      ${breakpoints.s} {
        &:focus-visible {
          outline: none;
        }
        &:focus-visible h4 {
          outline: none;
          color: ${colors.border_black};
          border-bottom: 2px solid ${colors.border_black};
          background-color: ${colors.skip_yellow};
          &hover h4,
          &:focus-visible h4 {
            text-decoration: underline;
            text-decoration-color: ${colors.border_black};
          }
        }
      }
    `,
    addressStyle: css`
      display: flex;
      align-items: center;
    `,
    title: css`
      text-decoration: underline;
      font-family: 'FS Dillon';
      color: ${colors.navy};
      text-transform: capitalize;
      text-align: left;
      font-size: 1rem;
      &:hover{
        font-family: 'FS Dillon Bold';
      }
      ${breakpoints.l} {
        font-size: 1rem;
      }
    `,
    titleWrapper: css`
      width: fit-content;
      position: relative;
      margin-bottom: 0.5rem;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -14px;
        width: 27px;
      }
    `,
    infoWrapper: css`
      display: grid;
      color: ${colors.navy};
      grid-gap: 0.3125rem;
      p {
        color: ${colors.gender_grey};
        max-width: 100%;
      }
      text-align: left;

      li::marker {
        color: ${colors.gender_grey};
      }
    `,
    strongFormat: css`
      font-size: 16px;
      color: ${colors.gender_grey};
      letter-spacing: 0.5px;
    `,
    listBullets: css`
      padding-left: 20px;
      list-style-type: disc;
    `,
    formatWrapper: css`
      > p {
        display: inline-block;
        &:not(:last-child):after {
          content: '|';
          padding: 0 ${spacing.xs};
          color: ${colors.gender_grey};
        }
      }
    `,
    externalLink: css`
      vertical-align: middle;
      color: ${colors.red};
      margin-left: 0.3125rem;
    `,
    infoAddress: css`
      text-transform: Capitalize;
    `,
    linkWrapper: css`
      padding-top: ${spacing.xs};
      button {
        padding: 0;
        text-decoration: none;
        font-weight: normal;
        text-transform: uppercase;

        &:focus {
          outline: 0;
          color: ${colors.navy};
          text-decoration: underline;
          svg {
            color: ${colors.navy};
          }
        }
      }
    `,
    infoValue: css`
      overflow: hidden;
      text-overflow: ellipsis;
    `,
    TeamName: utility.checkboxHidden,
  };
};
